import { Link, NavLink } from 'react-router-dom';
import './Voluntariado.css';
import { useLanguage } from '../i18n/LanguageContext';

export default function Voluntariado() {
  const { t, lang, toggleLanguage } = useLanguage();

  return (
    <div className="app">
      <header className="page-hero">
        <nav className="nav">
          <Link to="/" className="brand-link">
            <img
              src="/ceam-logo.png"
              className="brand-logo"
              alt="Centro Educativo Adventista de Monteverde"
            />
            <div className="brand-text">
              <span className="brand-title">{t('common.brand')}</span>
              <span className="brand-subtitle">{t('common.schoolName')}</span>
            </div>
          </Link>
          <div className="nav-actions">
            <NavLink to="/" className="btn ghost">{t('nav.home')}</NavLink>
            <NavLink to="/admisiones" className="btn ghost">{t('nav.admissions')}</NavLink>
            <NavLink to="/acerca-de" className="btn ghost">{t('nav.about')}</NavLink>
            <NavLink to="/ubicacion" className="btn ghost">{t('nav.contact')}</NavLink>
            <NavLink to="/voluntariado" className="btn ghost">{t('nav.volunteer')}</NavLink>
            <button type="button" className="btn ghost lang-toggle" onClick={toggleLanguage}>
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
          </div>
        </nav>
      </header>

      <section className="section volunteer-hero">
        <h1>{t('volunteer.title')}</h1>
        <p className="lead">{t('volunteer.lead')}</p>
        <div className="volunteer-cards">
          <article className="volunteer-card">
            <div className="volunteer-card-image">
              <img 
                src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&h=400&fit=crop" 
                alt="Voluntariado en Monteverde"
              />
            </div>
            <div className="volunteer-card-content">
              <h3>{t('volunteer.monteverde')}</h3>
              <p>{t('volunteer.monteverdeDesc')}</p>
              <a
                className="btn primary"
                href="https://vividfaith.com/link/Assignment/Search/id/VFBCG2"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('volunteer.button1')}
              </a>
            </div>
          </article>

          <article className="volunteer-card">
            <div className="volunteer-card-image">
              <img 
                src="https://images.unsplash.com/photo-1577896851231-70ef18881754?w=600&h=400&fit=crop" 
                alt="Voluntariado en Santa Elena"
              />
            </div>
            <div className="volunteer-card-content">
              <h3>{t('volunteer.santaElena')}</h3>
              <p>{t('volunteer.santaElenaDesc')}</p>
              <a
                className="btn primary"
                href="https://vividfaith.com/link/Assignment/Search/id/VFACSE"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('volunteer.button2')}
              </a>
            </div>
          </article>
        </div>
      </section>

      <footer className="footer">
        <p>{t('footer.rights')}</p>
      </footer>
    </div>
  );
}
